export enum RideStatus {
  PENDING = 'PENDING',
  SEARCHING_DRIVER = 'SEARCHING_DRIVER',
  DRIVER_ASSIGNED = 'DRIVER_ASSIGNED',
  DRIVER_ARRIVED = 'DRIVER_ARRIVED',
  STARTED = 'STARTED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  NO_DRIVERS_AVAILABLE = 'NO_DRIVERS_AVAILABLE',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  DRIVER_TIMEOUT = 'DRIVER_TIMEOUT',
}

export const RIDE_STATUS_ID_MAP: Record<number, RideStatus> = {
  1: RideStatus.PENDING,
  2: RideStatus.SEARCHING_DRIVER,
  3: RideStatus.DRIVER_ASSIGNED,
  4: RideStatus.DRIVER_ARRIVED,
  5: RideStatus.STARTED,
  6: RideStatus.COMPLETED,
  7: RideStatus.CANCELLED,
  8: RideStatus.NO_DRIVERS_AVAILABLE,
  9: RideStatus.PAYMENT_FAILED,
  10: RideStatus.DRIVER_TIMEOUT,
};

export const normalizeRideStatus = (status: string | number | null | undefined): RideStatus => {
  if (!status) return RideStatus.PENDING;

  if (typeof status === 'number') {
    return RIDE_STATUS_ID_MAP[status] || RideStatus.PENDING;
  }

  const upperStatus = status.toUpperCase();
  const statusKey = Object.keys(RideStatus).find(
    key => RideStatus[key as keyof typeof RideStatus] === upperStatus
  );

  if (statusKey) {
    return RideStatus[statusKey as keyof typeof RideStatus];
  }

  return RideStatus.PENDING;
};

export const isActiveRide = (status: string | number | null | undefined): boolean => {
  const normalizedStatus = normalizeRideStatus(status);
  return [RideStatus.DRIVER_ARRIVED, RideStatus.STARTED].includes(normalizedStatus);
};

export const isPendingRide = (status: string | number | null | undefined): boolean => {
  const normalizedStatus = normalizeRideStatus(status);
  return [RideStatus.PENDING, RideStatus.SEARCHING_DRIVER].includes(normalizedStatus);
};

export const isCompletedRide = (status: string | number | null | undefined): boolean => {
  const normalizedStatus = normalizeRideStatus(status);
  return [RideStatus.COMPLETED, RideStatus.CANCELLED].includes(normalizedStatus);
};
